var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHierarchy = function SvgHierarchy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    accessibilityRole: "image"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7 8.4C7.19117 8.4 8.4 7.19117 8.4 5.7C8.4 4.20883 7.19117 3 5.7 3C4.20883 3 3 4.20883 3 5.7C3 7.19117 4.20883 8.4 5.7 8.4Z",
    fill: "#037DD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3 14.7C19.7912 14.7 21 13.4912 21 12C21 10.5088 19.7912 9.3 18.3 9.3C16.8088 9.3 15.6 10.5088 15.6 12C15.6 13.4912 16.8088 14.7 18.3 14.7Z",
    fill: "#037DD6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7 21C7.19117 21 8.4 19.7912 8.4 18.3C8.4 16.8088 7.19117 15.6 5.7 15.6C4.20883 15.6 3 16.8088 3 18.3C3 19.7912 4.20883 21 5.7 21Z",
    fill: "#037DD6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7 16.275C5.331 16.275 5.025 15.969 5.025 15.6V8.4C5.025 8.031 5.331 7.725 5.7 7.725C6.069 7.725 6.375 8.031 6.375 8.4C6.375 10.371 7.329 11.325 9.3 11.325H15.6C15.969 11.325 16.275 11.631 16.275 12C16.275 12.369 15.969 12.675 15.6 12.675H9.3C8.076 12.675 7.095 12.36 6.375 11.766V15.6C6.375 15.969 6.069 16.275 5.7 16.275Z",
    fill: "#037DD6"
  })));
};
export default SvgHierarchy;